/**
 * «Что случилось с моей оплатой» — фраза, которую нужно донести до главного экрана.
 *
 * Правило выхода после оплаты одно на все клиенты: платёж закончился — спрашиваем сервер о его
 * судьбе; есть заказ, ведём в заказ; нет — на главную и объясняем, что произошло. Вторая половина
 * этого правила и живёт здесь: экран оплаты уходит с экрана в том же кадре, в котором ставит
 * объяснение, и всё, что он держал в своём состоянии, размонтируется вместе с ним.
 *
 * Устроено ровно как `paidToastStore` и по той же причине — значение переживает навигацию, потому
 * что лежит в модуле, а не в дереве. Отличается тем, чем отличается сообщение: тост про удачную
 * оплату сам уходит через четыре секунды, а это объяснение человек должен успеть прочитать и
 * убрать сам. Поэтому оно рисуется баннером на главной, а не всплывающей плашкой.
 *
 * Один раз и не переживает перезагрузку: фраза объясняет то, что случилось только что. Поднятая
 * из хранилища через сутки, она рассказывала бы про платёж неизвестной давности.
 */
type Listener = (text: string | null) => void;

let current: string | null = null;
const listeners = new Set<Listener>();

export function showPaymentNotice(text: string): void {
  current = text;
  for (const listener of listeners) listener(current);
}

export function dismissPaymentNotice(): void {
  if (current === null) return;
  current = null;
  for (const listener of listeners) listener(current);
}

export function subscribeToPaymentNotice(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Значение на момент подписки.
 *
 * `useSyncExternalStore` спрашивает его до того, как позовёт слушателя, — иначе объяснение,
 * поставленное в том же такте, в котором монтируется главная, потерялось бы.
 */
export function readPaymentNotice(): string | null {
  return current;
}
